import $ from "jquery";
import _ from "lodash";
import { subscribe as $subscribe } from "../../../../events/jQuerySubscription";
import { modalContentSelector } from "../../../modal";
import { EventEmitter } from "../../../../events/eventEmitter";
import { getPositionOf, positionDropDown } from "../../../../technical/dom";
import { getPrintable } from "../../../../technical/strings";
const listItemSelector = "li.custom-select-list-item";
export class CustomSelectImpl extends EventEmitter {
    constructor({ items, container, showSearch, name, renderInline, disabled, noneSelectedText, hidden, itemsVisibleOnShow = true, controlProvider, label, }) {
        super();
        this.subscriptions = [];
        this.mouseSubscriptions = [];
        this.listContainer = $();
        this.searchInput = $();
        this.customSelect = $();
        this.container = container;
        this.controlProvider = controlProvider;
        this.useAbsolutePositioning = !renderInline;
        this.disabled = disabled;
        this.name = name;
        this.showSearch = showSearch;
        this.items = items || [];
        this.noneSelectedText =
            noneSelectedText === undefined ? "None" : noneSelectedText;
        this.startHidden = hidden;
        this.itemsVisibleOnShow = itemsVisibleOnShow;
        this.label = label;
    }
    render() {
        this.listContainer = this.container.closest(modalContentSelector);
        if (!_.some(this.listContainer))
            this.listContainer = $("body");
        this.customSelect = $($("[data-custom-select]").html());
        this.controlProvider.initialise((item) => this.setSelected(item), this.customSelect, this.label);
        this.controlProvider.setName(this.name);
        this.setButtonDisabled();
        this.renderList();
        if (this.items) {
            this.renderItems(false, ...(this.itemsVisibleOnShow ? this.items : this.getEmptySearchItems()));
        }
        const stopPositionAutoUpdate = this.positionList();
        stopPositionAutoUpdate === null || stopPositionAutoUpdate === void 0 ? void 0 : stopPositionAutoUpdate();
        this.setDisplayText();
        this.insert(this.customSelect);
        this.searchInput = this.list.find("input");
        if (_.some(this.label))
            this.searchInput.attr("aria-label", this.label.text());
        if (this.startHidden)
            this.hide();
        this.subscriptions = [
            ...this.subscriptions,
            $subscribe($(document), "click", (e) => (this.searchKeys === undefined || this.searchKeys === " ") &&
                this.toggleList(e)),
            $subscribe($(document), "keydown", (e) => {
                var _a;
                const { key } = e;
                const maybePrintable = getPrintable(e);
                if (this.list.hasClass("custom-select-visible")) {
                    if (key === "Escape" || key === "Tab") {
                        this.hideList();
                        setTimeout(() => this.controlProvider.focus());
                        return;
                    }
                    if (key === "Enter" && this.controlProvider.canSubmit)
                        e.preventDefault();
                    if (key === "Enter" ||
                        (key === " " && this.searchKeys === undefined)) {
                        this.selectItems(this.getHighlightedItem());
                        const focusIsInList = document.activeElement &&
                            _.some(this.list.has(document.activeElement)) &&
                            !this.searchInput.is(":focus");
                        if (this.preventKeyboardClosure(e)) {
                            e.preventDefault();
                            return;
                        }
                        if (key === "Enter" || focusIsInList) {
                            e.preventDefault();
                            this.hideList();
                            setTimeout(() => this.controlProvider.focus());
                        }
                        return;
                    }
                    if (key === "ArrowUp" || key === "ArrowDown") {
                        e.preventDefault();
                        this.highlightNext(key);
                        return;
                    }
                    if (maybePrintable.isPrintable &&
                        document.activeElement !== this.searchInput[0] &&
                        document.activeElement !== ((_a = this.controlProvider.searchElement) === null || _a === void 0 ? void 0 : _a[0])) {
                        e.preventDefault();
                        this.updateSearchKeys(maybePrintable.character);
                        this.highlightBySearchKeys();
                        return;
                    }
                }
                else if (this.controlProvider.hasFocus()) {
                    if (key === "ArrowUp" || key === "ArrowDown") {
                        e.preventDefault();
                        this.selectNext(key);
                        return;
                    }
                    if (maybePrintable.isPrintable) {
                        this.updateSearchKeys(key);
                        this.selectBySearchKeys();
                        return;
                    }
                }
            }),
            $subscribe(this.searchInput, "input", () => this.search()),
            this.controlProvider.on("blur", () => this.emit("blur")),
        ];
        if (this.controlProvider.searchElement)
            this.subscriptions.push($subscribe(this.controlProvider.searchElement, "input", () => this.search()));
    }
    setValue(...values) {
        this.items
            .filter((item) => _.some(values, (v) => {
            if (v === null || v === undefined)
                return item.value === undefined || item.value === "";
            return v === item.value;
        }))
            .forEach((i) => this.setSelected(i));
        this.emit("change", false);
        this.setDisplayText();
    }
    getValue() {
        return this.items.filter((i) => i.selected);
    }
    cleanUp() {
        var _a;
        (_a = this.hideOnScrollSubscription) === null || _a === void 0 ? void 0 : _a.off();
        this.subscriptions.forEach((s) => s.off());
        this.mouseSubscriptions.forEach((s) => s.off());
    }
    enable() {
        this.disabled = false;
        this.setButtonDisabled();
    }
    disable() {
        this.disabled = true;
        this.setButtonDisabled();
    }
    get enabled() {
        return !this.disabled;
    }
    show() {
        this.customSelect.removeClass("hidden");
    }
    hide() {
        this.customSelect.addClass("hidden");
        this.hideList();
    }
    getItems() {
        return this.items;
    }
    addItems(...items) {
        this.addItemsInternal(true, ...items);
    }
    addItemsInternal(setSelected, ...items) {
        this.items = [...this.items, ...items];
        if (this.itemsVisibleOnShow)
            this.renderItems(setSelected, ...items);
    }
    renderList() {
        this.list = $($("[data-custom-select-list]").html());
        if (!this.showSearch && !_.some(this.controlProvider.searchElement))
            this.list.prop("tabIndex", "0");
        this.useAbsolutePositioning
            ? this.listContainer.append(this.list)
            : this.customSelect.append(this.list);
        this.resumeMouseListeners();
        this.subscriptions.push($subscribe(this.list, "click", listItemSelector, (e) => {
            this.selectItems($(e.currentTarget));
            setTimeout(() => this.controlProvider.focus());
        }));
    }
    renderItems(setSelected, ...items) {
        const clonedListItem = $($("[data-custom-select-list-item]").html());
        const clonedListGroup = $($("[data-custom-select-list-group]").html());
        const groups = items.reduce((a, i) => {
            if (i.groupLabel) {
                const existing = a.find((g) => g.groupLabel === i.groupLabel);
                if (existing) {
                    existing.items.push(i);
                }
                else {
                    a.push({ groupLabel: i.groupLabel, items: [i] });
                }
            }
            else {
                a.push({ items: [i] });
            }
            return a;
        }, []);
        const children = $(groups.flatMap((g) => {
            const groupItems = g.items.map((i) => {
                const listItem = clonedListItem.clone();
                listItem.children().first().html(i.displayName);
                listItem.data("item", Object.assign({}, i));
                if (i.selected)
                    listItem.addClass("selected").attr("aria-selected", "true");
                return listItem[0];
            });
            if (g.groupLabel) {
                const group = clonedListGroup.clone();
                group.find("[data-group-label]").text(g.groupLabel);
                group.find("ul").append(groupItems);
                return group[0];
            }
            else {
                return groupItems;
            }
        }));
        this.list.find("ul").append(children);
        if (setSelected && _.some(items, (i) => i.selected))
            this.selectItems(this.getListItems().filter(".selected"));
    }
    removeItems(...items) {
        $(this.getListItems()
            .toArray()
            .filter((li) => {
            const storedItem = $(li).data("item");
            return _.some(items, (i) => i.value === storedItem.value);
        })).remove();
        this.items = this.items.filter((storedItem) => !_.some(items, (i) => i.value === storedItem.value));
        if (!this.items.find((i) => i.selected))
            this.setValue(null);
    }
    removeAllItems() {
        this.items = [];
        this.list.find("ul").empty();
    }
    search() {
        const searchText = ((this.controlProvider.searchElement
            ? this.controlProvider.searchElement.val()
            : this.searchInput.val()));
        this.updateDisplayedItems(searchText);
    }
    updateDisplayedItems(searchText) {
        if (!this.itemsVisibleOnShow) {
            this.list.find("ul").empty();
            if (!searchText) {
                this.renderItems(false, ...this.getEmptySearchItems());
            }
            else {
                this.renderItems(false, ...this.items.filter((i) => i.displayName.toLowerCase().includes(searchText.toLowerCase())));
            }
            return;
        }
        this.getListItems()
            .toArray()
            .forEach((i) => {
            const listItem = $(i);
            const item = listItem.data("item");
            if (!searchText ||
                item.displayName.toLowerCase().includes(searchText.toLowerCase())) {
                listItem.removeClass("hidden");
            }
            else {
                listItem.addClass("hidden");
            }
        });
    }
    setButtonDisabled() {
        this.disabled ? this.controlProvider.disable() : this.controlProvider.enable();
    }
    resumeMouseListeners() {
        setTimeout(() => this.mouseSubscriptions.push($subscribe(this.list, "mouseenter", listItemSelector, (e) => {
            const item = $(e.currentTarget);
            this.getListItems().removeClass("custom-select-highlight");
            item.addClass("custom-select-highlight");
        }), $subscribe(this.list, "mouseleave", listItemSelector, (e) => $(e.currentTarget).removeClass("custom-select-highlight"))), 100);
    }
    suspendMouseListeners() {
        this.mouseSubscriptions.forEach((s) => s.off());
    }
    selectItems(chosenItems) {
        if (!_.some(chosenItems))
            return;
        chosenItems
            .toArray()
            .forEach((li) => this.setSelected(this.items.find((i) => i.value == $(li).data("item").value)));
        this.emit("change", true);
        this.setDisplayText();
    }
    setDisplayText() {
        this.controlProvider.setDisplayText(this.getDisplayText());
    }
    getHighlightedItem() {
        return this.list.find("li.custom-select-highlight").first();
    }
    toggleList(e) {
        if (this.shouldShowOnClick(e)) {
            this.showList();
        }
        else if (this.shouldHideOnClick(e)) {
            this.hideList();
        }
    }
    showList() {
        var _a;
        this.suspendMouseListeners();
        const items = this.getListItems();
        (_a = this.hideOnScrollSubscription) === null || _a === void 0 ? void 0 : _a.off();
        this.clearSearch();
        this.controlProvider.focus();
        items.removeClass("custom-select-highlight");
        this.list.addClass("custom-select-visible").attr("aria-expanded", "true");
        this.controlProvider.ariaExpanded = "true";
        if (this.showSearch) {
            this.searchInput.parent().removeClass("hidden");
            this.searchInput.trigger("focus");
        }
        else if (!_.some(this.controlProvider.searchElement)) {
            this.list.trigger("focus");
        }
        const selectedListItem = this.list.find("li.selected");
        if (selectedListItem.length === 1) {
            const { top } = getPositionOf({
                element: selectedListItem[0],
                relativeTo: this.list[0],
            });
            const scrollTop = this.list.scrollTop() || 0;
            const halfListHeight = (this.list.height() || 0) / 2;
            const halfItemHeight = (selectedListItem.height() || 0) / 2;
            this.list.scrollTop(scrollTop + top - (halfListHeight - halfItemHeight));
        }
        this.stopPositionAutoUpdate = this.positionList();
        this.resumeMouseListeners();
    }
    positionList() {
        this.list.css({
            minWidth: this.customSelect.outerWidth() || 0,
            maxHeight: "15rem",
        });
        if (!this.useAbsolutePositioning)
            return;
        return positionDropDown({
            element: this.list,
            relativeTo: this.customSelect,
            placement: "bottom-start",
            padding: 4,
            minHeight: 350,
            maxHeight: window.innerHeight * 0.8,
        });
    }
    clearSearch() {
        this.searchInput.val("");
        this.getListItems().removeClass("hidden");
    }
    shouldShowOnClick(e) {
        return (!this.disabled &&
            $(e.target).closest(".custom-select")[0] === this.customSelect[0] &&
            !this.list.hasClass("custom-select-visible"));
    }
    highlightNext(key) {
        const defaultItem = key === "ArrowUp" ? "last" : "first";
        const nextItem = key === "ArrowUp" ? -1 : 1;
        const items = this.getListItems().not(".hidden");
        const itemsArray = items.toArray();
        const highlightedIndex = itemsArray.findIndex((i) => $(i).hasClass("custom-select-highlight"));
        let item = $(itemsArray[highlightedIndex + nextItem]);
        if (!_.some(item))
            item = items[defaultItem]();
        this.highlight(item);
    }
    highlightBySearchKeys() {
        if (!this.searchKeys)
            return;
        const item = this.getListItems()
            .toArray()
            .find((l) => $(l).data("item").displayName
            .toLowerCase()
            .startsWith(this.searchKeys.toLowerCase()));
        item && this.highlight($(item));
    }
    updateSearchKeys(key) {
        clearTimeout(this.searchKeyTimeout);
        this.searchKeys = `${this.searchKeys || ""}${key}`;
        this.searchKeyTimeout = setTimeout(() => {
            this.searchKeys = undefined;
            clearTimeout(this.searchKeyTimeout);
        }, 500);
    }
    highlight(item) {
        const items = this.getListItems();
        items.removeClass("custom-select-highlight");
        item.addClass("custom-select-highlight").trigger("focus");
        this.suspendMouseListeners();
        item[0].scrollIntoView({ block: "nearest", inline: "nearest" });
        this.resumeMouseListeners();
    }
    hideList() {
        var _a;
        (_a = this.stopPositionAutoUpdate) === null || _a === void 0 ? void 0 : _a.call(this);
        this.list.removeClass("custom-select-visible").attr("aria-expanded", "false");
        this.controlProvider.ariaExpanded = "false";
        if (!this.itemsVisibleOnShow) {
            this.list.find("ul").empty();
            this.renderItems(false, ...this.getEmptySearchItems());
        }
    }
    getEmptySearchItems() {
        var _a;
        return ((_a = this.items) === null || _a === void 0 ? void 0 : _a.filter((i) => !i.value || i.selected)) || [];
    }
    getListItems() {
        return this.list.find(listItemSelector);
    }
}
